import http from "./../../services/http";

export const categoriesRequest = () => {
  return http.get("categories");
};
